import { useEffect, useState, Fragment } from "react";
import MainSidebar from "./MainSidebar";
import NavSidebar from "./NavSidebar";
import { NavItem, NavLink } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { closeSidebar, setSidebarOpen, } from "../../redux/reducer/userReducer";

export default function Sidebar() {
  const [menuActive, setMenuActive] = useState();
  const [activePath, setActivePath] = useState('');
  const { user } = useSelector((state) => state?.auth);
  const { pathname } = useLocation();
  const dashboard = pathname.match(/^\/dashboard/) ? "active" : "";
  const dispatch = useDispatch();

  const handleLinkClicked = (e) => {
    dispatch(closeSidebar())
    e.stopPropagation();
  };

  useEffect(() => {
    setActivePath(pathname);
  }, [pathname]);

  return (
    <MainSidebar brandName="NTSC">
      <NavSidebar>
        <NavItem onClick={handleLinkClicked}>
          <NavLink tag={Link} to="/dashboard" className={dashboard}>
            <i className="nav-icon icon icon-dashboard"></i>
            <p>Dashboard</p>
          </NavLink>
        </NavItem>
        {user?.menuList?.map((menu) => {
          return (
            <Fragment key={menu?.menuName}>
              {menu?.subMenus.length > 0 ?
                <NavItem
                  key={menu?.menuName}
                  onClick={() => {
                    setMenuActive(menuActive === menu?.menuName ? '' : menu?.menuName);
                  }}
                  className={
                    menu?.menuName === menuActive ? "nav-item menu-is-opening menu-open" : ""
                  }
                >
                  <NavLink href="#">
                    <i className={`nav-icon icon ${menu?.menuIcon}`}></i>
                    <p>
                      {menu?.menuName}
                      <FontAwesomeIcon icon={faAngleLeft} className="right" />
                    </p>
                  </NavLink>
                  <ul className="nav nav-treeview">
                    {menu?.subMenus?.map((item) => {
                      return (
                        <NavItem key={item?.menuName} onClick={handleLinkClicked}>
                          <NavLink tag={Link} to={item?.menuURL} className={`/${item?.menuURL}` == activePath ? "active" : ''}>
                            <i className={`nav-icon icon fa ${item?.menuIcon}`}></i>
                            <p>{item?.menuName}</p>
                          </NavLink>
                        </NavItem>
                      )
                    })}
                  </ul>
                </NavItem>
                :
                <NavItem
                  key={menu?.menuName}
                  onClick={handleLinkClicked}>
                  <NavLink tag={Link} to={menu?.menuURL} className={`/${menu?.menuURL}` == activePath ? "active" : ''}>
                    <i className={`nav-icon fa ${menu?.menuIcon}`}></i>
                    <p>{menu.menuName}</p>
                  </NavLink>
                </NavItem>
              }
            </Fragment>
          )
        })}
      </NavSidebar>
    </MainSidebar>
  );
}
